<template>
  <div class="mb-5 overflow-hidden">
    <div v-for="(value, key, index) in ref_stats.total.details" :key="key">
      <div v-if="key !== 'all'" class="pb-2">
        <div class="flex justify-between items-center mb-2">
          <span class="text-base" :class="[$theme.tabTextColor]">
            {{ $t(key) }}
          </span>
          <span class="text-sm font-bold" :class="[$theme.baseTextColor]">
            {{ value }}
          </span>
        </div>
        <div class="w-full rounded-full h-2 relative">
          <div class="absolute w-full h-1px border" :class="[$theme.borderBlockColor]"></div>
          <div
              :class="barColors[index % barColors.length]"
              class="h-2 relative"
              :style="{ width: `${calculatePercentage(value)}%` }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ref_stats'],
  data() {
    return {
      barColors: [
        'm-green-bg',
        'm-green-bg',
        'm-green-bg',
        'm-green-bg',
        'm-green-bg',
        'm-green-bg',
      ]
    };
  },
  computed: {
    totalCount() {
      // Суммируем все значения, исключая ключ "all"
      return Object.entries(this.ref_stats.total.details)
          .filter(([key]) => key !== 'all') // Исключаем ключ "all"
          .reduce((sum, [, value]) => sum + parseFloat(value), 0);
    }
  },
  methods: {
    calculatePercentage(value) {
      // Рассчитываем процент от общего количества
      return this.totalCount > 0
          ? ((parseFloat(value) / this.totalCount) * 100).toFixed(2)
          : 0;
    },

    showEmoji(key) {
      if (key === 'started') {
        return '🤖';
      }

      if (key === 'term_apply') {
        return '📄';
      }

      if (key === 'contact_filled') {
        return '☎️';
      }

      if (key === 'tariff_payed') {
        return '✅';
      }

      if (key === 'trade_started') {
        return '🎉';
      }

      return '';
    }
  }
};
</script>